export enum EFeatureGates {
  ADMIN_ACCESS = 'admin_access',
  REQUEST_PHOTOS = 'request_photos_button',
  FRIENDSHIP_TIMELINE = 'friendship_timeline',
  RECAPTCHA = 'recaptcha',
  DISCOVER_FILTER = 'discover_filter',
  FORGOT_PASSWORD = 'forgot_password',
  JUST_ADDED_MEDIA = 'just_added_media',
  FEEDBACK_CONTROLS = 'feedback_controls',
  FEEDBACK_CONTROLS_MEDIA = 'feedback_controls_media',
  FEEDBACK_CONTROLS_CHAT = 'feedback_controls_chat',
  HOMEPAGE_BANNER = 'homepage_banner',
  UNIFIED_MEDIA_GENERATION_SERVICE = 'unified_media_generation_service',
  VOICE_CALL = 'voice_call'
}
